import React, { useState } from "react";
import "../../styles/main.css";
import theme from "../../styles/theme";
import ContainerBase from "../../components/framepart/SubpageLayout/ContainerBase";
import JourneyTabsCorelia from "./components/reusable/JourneyTabs";
import CostBanner from "./components/reusable/Banner";
import Button from "./components/reusable/Button";

import ZoneA1 from "./panels/LeftPanel_102_ZoneA1";
import ZoneA2 from "./panels/RightPanel_102_ZoneA2";

import DrawSpace25D from "./Tools/drawspace25D/DrawSpace25D";
import ZonePP from "./Tools/drawspace25D/components/DrawPropertiesPanel";

import TestMultiProject from "../../modules/caneva/Tools/drawspace25D/TestMultiProject";


/* ============================================================
   OPTIONS GÉNÉRIQUES
============================================================ */
const demoOptions = [
  { value: "opt1", label: "Option 1" },
  { value: "opt2", label: "Option 2" },
  { value: "opt3", label: "Option 3" },
];
const projectIdentity = {
  projectName: "Demo Project",
  reference: "PRJ-001",
  clientName: "Client Demo",
  location: "Project Location",
  projectType: "Infrastructure / Building",
  country: "—",
};
/* ============================================================
   CONSTANTES TABS
============================================================ */
const TAB_KEYS = {
  PACKAGE: 0,
  COST: 1,
  QUANTITIES: 2,
  COSTING: 3,
  REVIEW: 4,
  REPORT: 5,
};
/* ============================================================
   BANNER CONFIGURATION (Données Mock)
============================================================ */
const bannerConfigByTab = {
  [TAB_KEYS.PACKAGE]: {
    overline: "CORELIA BUILDER 2.5D",
    title: "Modélisaton des systèmes",
    metrics: [
      { label: "Packages", value: 12 },
      { label: "Structured", value: 8 },
      { label: "Coverage", value: "Initial" },
    ],
    showMetrics: true,
    showFilters: true,
    showLegends: true,
    filterOptions: ["Structure", "Coverage", "Readiness"],
    legends: [
      { label: "Structured", color: theme?.colors?.text?.corelia || "#0e3f56" },
      { label: "Ready", color: theme?.colors?.text?.green || "#1A8C74" },
      { label: "To complete", color: "#B8621B" },
    ],
  },
  [TAB_KEYS.COST]: {
    overline: "Cost structure",
    title: "Matching des sous-éléments avec le catalogue de coûts Corelia",
    metrics: [
      { label: "Matched articles", value: 2 },
      { label: "Catalog results", value: 8 },
      { label: "Coverage", value: "Partial" },
    ],
    showMetrics: true,
    showFilters: true,
    showLegends: true,
    filterOptions: ["Matching", "Coverage", "Catalog"],
    legends: [
      { label: "Matched", color: theme?.colors?.text?.corelia || "#0e3f56" },
      { label: "Ready", color: theme?.colors?.text?.green || "#1A8C74" },
      { label: "To complete", color: "#B8621B" },
    ],
  },
  [TAB_KEYS.QUANTITIES]: {
    overline: "Quantities",
    title: "Consolidation des quantités et logique empirique de quantification",
    metrics: [
      { label: "Lines", value: 0 },
      { label: "Defined", value: 0 },
      { label: "Rule-based", value: 0 },
    ],
    showMetrics: true,
    showFilters: true,
    showLegends: true,
    filterOptions: ["Quantities", "Drivers", "Rules"],
    legends: [
      { label: "Manual", color: theme?.colors?.text?.corelia || "#0e3f56" },
      { label: "Inherited", color: theme?.colors?.text?.green || "#1A8C74" },
      { label: "Rule", color: theme?.colors?.text?.caneva || "#c24c2c" },
    ],
  },
  [TAB_KEYS.COSTING]: {
    overline: "Costing",
    title: "Construction du chiffrage et bases d’évaluation",
    metrics: [{ label: "Items", value: 0 }],
    showMetrics: true,
    showFilters: true,
    showLegends: false,
    filterOptions: ["Costing"],
    legends: [],
  },
  [TAB_KEYS.REVIEW]: {
    overline: "Review",
    title: "Contrôle et revue de la structure budgétaire",
    metrics: [{ label: "Open points", value: 0 }],
    showMetrics: true,
    showFilters: true,
    showLegends: false,
    filterOptions: ["Review"],
    legends: [],
  },
  [TAB_KEYS.REPORT]: {
    overline: "Report",
    title: "Préparation des livrables et synthèses",
    metrics: [{ label: "Reports", value: 0 }],
    showMetrics: true,
    showFilters: true,
    showLegends: false,
    filterOptions: ["Report"],
    legends: [],
  },
};
/* ============================================================
   STYLES DE PAGE
============================================================ */
const pageRootStyle = {
  padding: 0,
  margin: 0,
  width: "100%",
  height: "100%",
  minWidth: 0,
  minHeight: 0,
  overflow: "visible",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  
};
const leftColumnShellStyle = {
  flex: "0 0 80%",
  width: "80%",
  height: "100%",
  minWidth: 0,
  minHeight: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  padding: "0",
  
  
};
const a1SplitLayoutStyle = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  height: "100%",
  minWidth: 0,
  minHeight: 0,
  gap: 12,
  boxSizing: "border-box",
  
 
};
const a1MainStyle = {
  flex: "0 0 85%",
  width: "90%",
  minWidth: 0,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "visible",
  boxSizing: "border-box",
  
};
const a1PropertiesStyle = {
  flex: "0 0 22%",
  width: "22%",
  minWidth: 0,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  boxSizing: "border-box",
  paddingLeft: 12,
};
const rightColumnShellStyle = {
  flex: "0 0 20%",
  width: "20%",
  height: "100%",
  minWidth: 0,
  minHeight: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
   padding: "0",
};
const baseLeftZoneStyle = {
  flex: 3,
  minWidth: "800",
  minHeight: "calc(100vh - 290px)",
  padding: 0,
  borderRadius: 6,
  overflowX: "auto",
  overflowY: "auto",
  flexShrink: 0,
};
const baseRightZoneStyle = {
  flex: 1,
  minWidth: 250,
  minHeight: "calc(100vh - 290px)",
  padding: 12,
  borderRadius: 6,
  background: "transparent",
  //border: `1px solid ${theme.colors.borders.default}`,
  overflowX: "auto",
  overflowY: "auto",
  boxSizing: "border-box",
  flexShrink: 0,
  transition: "flex 0.16s ease, min-width 0.16s ease, max-width 0.16s ease",
};
const placeholderStyle = {
  width: "100%",
  minHeight: 220,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme?.colors?.text?.small || "#5C7A89",
  fontSize: 14,
  lineHeight: 1.5,
  padding: 24,
  boxSizing: "border-box",
};

/* ============================================================
   SUBPAGE COMPONENT
============================================================ */
const Subpage_102_beta = ({ leftZone, rightZone, property }) => {
  const [activeTab, setActiveTab] = useState(TAB_KEYS.PACKAGE);
  const [selectedFilter, setSelectedFilter] = useState("");
  
// Draw Space 2.5D
  const [selectedSpatialEntity, setSelectedSpatialEntity] = useState(null);
  const [editedSpatialEntity, setEditedSpatialEntity] = useState(null);
  const [spatialEntities] = useState([
    {
      id: "site-main",
      spatialType: "SITE",
      name: "Main Site",
      elevation: 0,
      area: 12000,
      perimeter: 460,
    },
    {
      id: "level-rdc",
      spatialType: "LEVEL",
      name: "Ground Floor",
      elevation: 0,
      area: 2400,
      perimeter: 210,
    },
    {
      id: "level-r1",
      spatialType: "LEVEL",
      name: "Level 1",
      elevation: 4,
      area: 2200,
      perimeter: 205,
    },
    {
      id: "zone-a",
      spatialType: "ZONE",
      name: "Zone A",
      elevation: 0,
      area: 450,
      perimeter: 98,
    },
    {
      id: "zone-b",
      spatialType: "ZONE",
      name: "Zone B",
      elevation: 0,
      area: 620,
      perimeter: 114,
    },
  ]);

  const tabs = [
    { label: "Corelia Builder", subTitle: "Gestion de l'espace" },
    { label: "Building Systems", subTitle: "Systèmes du bâtiment" },
    { label: "Technical Systems", subTitle: "Systèmes techniques" },
    { label: "Civil Systems", subTitle: "Systèmes civils" },
    { label: "Scope Summary", subTitle: "Résumé de l'étendue" },
    { label: "Report", subTitle: "Livrables et synthèse" },
  ];
  const onTabChange = (index) => {
    setActiveTab(index);
  };

  const onFilterChange = (filter) => {
    setSelectedFilter(filter);
    console.log("Selected filter:", filter);
  };
  const zoneA1 = {
  style: { ...baseLeftZoneStyle, padding: "10px"},
  gap: 12,
  sectionGap: 6,
  width: 250,
    
  
  sections: [
    {
      title: "",
      content: (
        <div style={a1SplitLayoutStyle}>
          <div style={a1MainStyle}>
            {/* <DrawSpace25D */}
            <TestMultiProject 
              assetId="demo-asset"
              width="100%"
              height="95%"
              assetLabel="Asset"
              showToolbar={true}
              showFloorBar={false}
              showPropertiesPanel={false}
              showGrid={true}
              enablePersistence={false}
              enablePrint={true}
              readOnlyMode={false}
              disabled={false}
              printTitle="Spatial Plan"
              printOrientation="landscape"
              editedEntity={editedSpatialEntity}
              onChange={(data) => console.log("DrawSpace changed:", data)}
              onSelectionChange={(entity) => {
                setSelectedSpatialEntity(entity);
                setEditedSpatialEntity(entity);
              }}
              onDataLoaded={(data) => console.log("DrawSpace loaded:", data)}
            />
          </div>

          <div style={a1PropertiesStyle}>
            <ZonePP
              entity={editedSpatialEntity}
              activeMode="NIVEAU"
              onChange={setEditedSpatialEntity}
            />
          </div>
        </div>
      ),
    },
  ],
};
  const zoneA2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    width: 260,
     
    sections: [
      {
        title: "",
        content: <ZoneA2 />,
      },
    ],
  };
  const zoneB1 = {
    style: baseLeftZoneStyle,
    gap: 12,
    sectionGap: 6,
    width: 250,
    sections: [
      {
        title: "",
        content: "",
      },
    ],
  };
  const zoneB2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    width: 250,
    sections: [
      {
        title: "",
        content: (
          <div style={placeholderStyle}>
            Panneau droit — Cost structure
          </div>
        ),
      },
    ],
  };
  const zoneC1 = {
    style: baseLeftZoneStyle,
    gap: 12,
    sectionGap: 6,
    width: 250,
    sections: [
      {
        title: "",
        content: (
          <div style={placeholderStyle}>
            Contenu Quantities à connecter
          </div>
        ),
      },
    ],
  };
  const zoneC2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    width: 250,
    sections: [
      {
        title: "",
        content: (
          <div style={placeholderStyle}>
            Panneau Quantities à connecter
          </div>
        ),
      },
    ],
  };
  const zoneD1 = {
    style: baseLeftZoneStyle,
    gap: 12,
    sectionGap: 6,
    width: 250,
    sections: [
      {
        title: "",
        content: (
          <div style={placeholderStyle}>
            Contenu Costing à connecter
          </div>
        ),
      },
    ],
  };
  const zoneD2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    width: 250,
    sections: [
      {
        title: "",
        content: (
          <div style={placeholderStyle}>
            Panneau Costing à connecter
          </div>
        ),
      },
    ],
  };
  const zoneE1 = {
    style: baseLeftZoneStyle,
    gap: 12,
    sectionGap: 6,
    width: 250,
    sections: [
      {
        title: "",
        content: (
          <div style={placeholderStyle}>
            Contenu Review à connecter
          </div>
        ),
      },
    ],
  };
  const zoneE2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    width: 250,
    sections: [
      {
        title: "",
        content: (
          <div style={placeholderStyle}>
            Panneau Review à connecter
          </div>
        ),
      },
    ],
  };
  const zoneF1 = {
    style: baseLeftZoneStyle,
    gap: 12,
    sectionGap: 6,
    width: 250,
    sections: [
      {
        title: "",
        content: (
          <div style={placeholderStyle}>
            Contenu Report à connecter
          </div>
        ),
      },
    ],
  };
  const zoneF2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    width: 250,
    sections: [
      {
        title: "",
        content: (
          <div style={placeholderStyle}>
            Panneau Report à connecter
          </div>
        ),
      },
    ],
  };
  const zonesByTab = {
    [TAB_KEYS.PACKAGE]: {
      left: zoneA1,
      right: zoneA2,
    },
    [TAB_KEYS.COST]: {
      left: zoneB1,
      right: zoneB2,
    },
    [TAB_KEYS.QUANTITIES]: {
      left: zoneC1,
      right: zoneC2,
    },
    [TAB_KEYS.COSTING]: {
      left: zoneD1,
      right: zoneD2,
    },
    [TAB_KEYS.REVIEW]: {
      left: zoneE1,
      right: zoneE2,
    },
    [TAB_KEYS.REPORT]: {
      left: zoneF1,
      right: zoneF2,
    },
  };
  const currentBanner =
    bannerConfigByTab[activeTab] || bannerConfigByTab[TAB_KEYS.PACKAGE];
  const currentZones = zonesByTab[activeTab] || {
    left: leftZone || zoneA1,
    right: rightZone || zoneA2,
  };
  return (
    <div style={pageRootStyle }>
      <JourneyTabsCorelia
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={onTabChange}
        componentWidth="60%"
        stepsWidth="100%"
        componentOffsetLeft={0}
        headerPaddingLeft={24}
        tabsDisabled={false}
        containerStyle={{
          width: "100%",
          height: "100%",
          minHeight: 0,
          minWidth: 0,
          margin: -0,
          marginTop:-20,
          padding: 0,
          gap:15,
          overflow: "visible",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
        }}
      />
      <div style={{ display: "flex",flex: 1,
    minHeight: 0,
    minWidth: 0, }}>
        <div style={leftColumnShellStyle}>
          <div style={{ marginBottom: "-10px" , marginTop: "-10px" ,padding: "10px"}}>
            <CostBanner
              {...currentBanner}
              onFilterChange={onFilterChange}
            />

          </div >
          <ContainerBase {...currentZones.left} />
        </div>
        
        <div style={rightColumnShellStyle}>
          <ContainerBase {...currentZones.right}  />
        </div>
      </div>
    </div>
  );
};

export default Subpage_102_beta;